module.exports = __webpack_public_path__ + "static/media/AnsArrow.4f86413a.svg";